import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import { displayValue, hasAnyValue } from "../../../../../../../utils/commonFunctions/displayValue";
import MeasurementTable from "./MeasurementTable";
import "./ScanDetailsSections.css";

const ScanAdditionalMeasurements = ({ legScan }: ILegScanProps) => {
	const archAreaRows = [
		{ label: "Med Arch Area", left: legScan.left_med_arch_area, right: legScan.right_med_arch_area },
		{ label: "Med Arch Volume", left: legScan.left_med_arch_volume, right: legScan.right_med_arch_volume },
		{
			label: "Foot Projection Area",
			left: legScan.left_foot_projection_area,
			right: legScan.right_foot_projection_area
		},
		{
			label: "Arch Area Relative Height",
			left: legScan.left_arch_area_relative_height,
			right: legScan.right_arch_area_relative_height
		},
		{ label: "Shoe Width", left: legScan.left_shoe_width, right: legScan.right_shoe_width }
	];

	const footProfileRows = [
		{ label: "Width Type", left: legScan.width_type_left, right: legScan.width_type_right },
		{ label: "Instep Height", left: legScan.left_instep_height, right: legScan.right_instep_height }
	];

	const profileFields = [
		{ label: "Weight", value: displayValue(legScan.weight, "kg") },
		{ label: "BMI", value: displayValue(legScan.BMI) },
		{ label: "Weight Bearing %", value: displayValue(legScan.weight_bearing_percent) },
		{ label: "Device Age", value: displayValue(legScan.device_age) },
		{ label: "Device Height", value: displayValue(legScan.device_height) },
		{ label: "Dress Shoe Size", value: displayValue(legScan.dress_shoe_size) },
		{ label: "Athletic Shoe Size", value: displayValue(legScan.athletic_shoe_size) },
		{ label: "Casual Shoe Size", value: displayValue(legScan.casual_shoe_size) },
		{ label: "Heels Shoe Size", value: displayValue(legScan.heels_shoe_size) }
	];
	const showProfileFields = hasAnyValue([
		legScan.weight,
		legScan.BMI,
		legScan.weight_bearing_percent,
		legScan.device_age,
		legScan.device_height,
		legScan.dress_shoe_size,
		legScan.athletic_shoe_size,
		legScan.casual_shoe_size,
		legScan.heels_shoe_size
	]);

	const optionalInputEntries = Object.entries(legScan.optional_inputs || {}).filter(
		([, val]) => val !== "" && val !== null
	);

	return (
		<>
			<div className="measurement-tables-row">
				<MeasurementTable title="Arch Area / Volume" rows={archAreaRows} />
				<MeasurementTable title="Foot Profile" unit="mm" rows={footProfileRows} />
			</div>

			{showProfileFields ? (
				<div className="scan-header-info">
					{profileFields
						.filter((field) => field.value !== "—")
						.map((field) => (
							<div className="scan-header-info-item" key={field.label}>
								<p className="scan-header-info-label">{field.label}</p>
								<p className="scan-header-info-value">{field.value}</p>
							</div>
						))}
				</div>
			) : null}

			{optionalInputEntries.length > 0 ? (
				<div className="optional-inputs-grid">
					{optionalInputEntries.map(([key, value]) => (
						<div className="scan-header-info-item" key={key}>
							<p className="scan-header-info-label">{key}</p>
							<p className="scan-header-info-value">{value}</p>
						</div>
					))}
				</div>
			) : null}
		</>
	);
};

export default ScanAdditionalMeasurements;
